import React from 'react';
import Home from './pages/Home/Home';
import Player from './pages/Player/Player';
import MockDraft from './pages/MockDraft/MockDraft';
import Ranking from './pages/Ranking/Ranking';
import ConsensusRankings from './pages/ConsensusRankings/ConsensusRankings';
import IndependentRankings from './pages/IndependentRankings/IndependentRankings';
import IndependentRanking from './pages/IndependentRanking/IndependentRanking';
import MocksAndRankings from './pages/MocksAndRankings/MocksAndRankings';
import BlogPost from './pages/BlogPost/BlogPost';
import BlogPosts from './pages/BlogPosts/BlogPosts';
import AboutUs from './pages/AboutUs/AboutUs';
import Top64Competition from './pages/Top64Competition/Top64Competition';
import ProspectPreview from './pages/ProspectPreview/ProspectPreview';
import ProspectPreviewTeam from './pages/ProspectPreview/ProspectPreviewTeam';
import BlindDraft from './pages/BlindDraft/BlindDraft';
import Players from './pages/Players/Players';
import Team from './pages/Team/Team';
import NavBar from './components/NavBar/NavBar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Footer from './components/Footer/Footer';
import DraftOrder from './pages/DraftOrder/DraftOrder';
import DraftOdds from './pages/DraftOdds/DraftOdds';
import DraftDebuts from './pages/DraftDebuts/DraftDebuts';
import DraftHub from './pages/DraftHub/DraftHub';
import LiveDraft from './pages/LiveDraft/LiveDraft';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import PlayerComparison from './pages/PlayerComparison/PlayerComparison';
import FAQ from './pages/FAQ/FAQ';
import DraftYearPicker from './components/DraftYearPicker/DraftYearPicker';
import Login from './pages/Login/Login';
import YourRankings from './pages/YourRankings/YourRankings';
import CreateRanking from './pages/CreateRanking/CreateRanking';
import EditRanking from './pages/EditRanking/EditRanking';
import Profile from './pages/Profile/Profile';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import { DraftYearProvider } from './contexts/DraftYearContext';
import { AuthProvider } from './contexts/AuthContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import CookieConsent from './components/CookieConsent/CookieConsent';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

import './App.css';

function LegacyMocksAndRankingsRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/media-rankings', search }} replace />;
}

const STANDALONE_ROUTES = new Set(['/blind-draft']);

function AppShell() {
  const { pathname } = useLocation();
  const isStandalone = STANDALONE_ROUTES.has(pathname);

  return (
    <div id="page-container">
      <div id="content-wrap">
        <DraftYearProvider>
          {!isStandalone && <NavBar />}
          {!isStandalone && <DraftYearPicker />}
          <Routes>
                <Route exact path="" element={<Home />} />
                <Route exact path="consensus-rankings" element={<ConsensusRankings />} />
                <Route exact path="draft-odds" element={<DraftOdds />} />
                <Route exact path="draft-debuts" element={<DraftDebuts />} />
                <Route exact path="draft-hub" element={<DraftHub />} />
                <Route path="/live-draft" element={<LiveDraft />} />
                <Route exact path="player/:player_id" element={<Player />} />
                <Route exact path="independent-rankings" element={<IndependentRankings />} />
                <Route exact path="independent-rankings/:independent_ranking_id" element={<IndependentRanking />} />
                <Route exact path="media-rankings" element={<MocksAndRankings />} />
                <Route exact path="mocks-and-rankings" element={<LegacyMocksAndRankingsRedirect />} />
                <Route exact path="mock-draft/:mock_draft_id" element={<MockDraft />} />
                <Route exact path="ranking/:ranking_id" element={<Ranking />} />
                <Route exact path="team/:team_id" element={<Team />} />
                <Route exact path="players" element={<Players />} />
                <Route exact path="blog-post/:blog_post_id" element={<BlogPost />} />
                <Route exact path="blog" element={<BlogPosts />} />
                <Route exact path="draft-order" element={<DraftOrder />} />
                <Route exact path="draft-results" element={<DraftOrder />} />
                <Route exact path="about-us" element={<AboutUs />} />
                <Route exact path="player-comparison" element={<PlayerComparison />} />
                <Route exact path="terms-of-service" element={<TermsOfService />} />
                <Route exact path="faq" element={<FAQ />} />
                <Route exact path="top-64-competition" element={<Top64Competition />} />
                <Route exact path="prospect-preview" element={<ProspectPreview />} />
                <Route exact path="prospect-preview/:team_id" element={<ProspectPreviewTeam />} />
                <Route exact path="blind-draft" element={<BlindDraft />} />
                <Route exact path="login" element={<Login />} />
                <Route exact path="verify-email" element={<VerifyEmail />} />
                <Route exact path="reset-password" element={<ResetPassword />} />
                <Route exact path="profile" element={<Profile />} />
                <Route exact path="profile/:user_id" element={<Profile />} />
                <Route exact path="your-rankings" element={<YourRankings />} />
                <Route exact path="your-rankings/create" element={<CreateRanking />} />
                <Route
                  exact
                  path="your-rankings/:independent_ranking_id/edit"
                  element={<EditRanking />}
                />
          </Routes>
        </DraftYearProvider>
      </div>
      {!isStandalone && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <CookieConsentProvider>
        <ScrollToTop />
        <AppShell />
        <CookieConsent />
        </CookieConsentProvider>
      </AuthProvider>
    </Router>
  )
}

export default App;
